import {Referrals} from './referrals.ts';

export const referrals = new Referrals();
